(function () {
  var glowSyncByRoot = new WeakMap();
  var globalGlowBound = false;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function isProductPage() {
    return !!(document.body && document.body.classList.contains('template-product'));
  }

  function normalizeHex(hex) {
    if (hex && typeof hex === 'object') {
      hex = hex.toString ? hex.toString() : '';
    }
    if (!hex || typeof hex !== 'string') return null;
    var cleaned = hex.trim();
    if (!cleaned) return null;
    if (cleaned.charAt(0) !== '#') cleaned = '#' + cleaned;
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(cleaned)) return null;
    return cleaned;
  }

  function lightenHex(hex, amount) {
    var cleaned = normalizeHex(hex);
    if (!cleaned) return '#3D9970';
    var raw = cleaned.slice(1);
    if (raw.length === 3) {
      raw = raw
        .split('')
        .map(function (c) {
          return c + c;
        })
        .join('');
    }
    var r = parseInt(raw.slice(0, 2), 16);
    var g = parseInt(raw.slice(2, 4), 16);
    var b = parseInt(raw.slice(4, 6), 16);
    var mix = function (channel) {
      return Math.round(channel + (255 - channel) * amount);
    };
    var toHex = function (n) {
      var h = n.toString(16);
      return h.length === 1 ? '0' + h : h;
    };
    return '#' + toHex(mix(r)) + toHex(mix(g)) + toHex(mix(b));
  }

  function applyGlow(root, hex) {
    var color = normalizeHex(hex) || '#246844';
    var mid = lightenHex(color, 0.35);
    var flow =
      'linear-gradient(90deg, ' + color + ' 0%, ' + mid + ' 50%, ' + color + ' 100%)';
    var staticGrad =
      'linear-gradient(90deg, ' + color + ' 0%, ' + mid + ' 100%)';

    function paint(el) {
      if (!el || !el.style) return;
      el.style.setProperty('--rb-variant-glow', color);
      el.style.setProperty('--rb-feature-color', color);
      el.style.setProperty('--rb-feature-mid', mid);
      el.style.setProperty('--rb-atc-hover-gradient', flow);
      el.style.setProperty('--rb-atc-hover-gradient-static', staticGrad);
      el.style.setProperty('--rb-atc-hover-gradient-size', '200% 100%');
    }

    paint(root);
    paint(document.body);
    paint(document.documentElement);

    document
      .querySelectorAll(
        '.t4s-product__info-wrapper, .prod_des .pdf, .prod_des .pad, .prod_des .pbu, .hwtusecon, .hwto'
      )
      .forEach(paint);

    var critical = document.getElementById('rb-variant-glow-critical');
    if (critical) {
      critical.textContent =
        'html.template-product,body.template-product,' +
        'body.template-product .t4s-product__info-wrapper,' +
        'body.template-product .prod_des .pdf,' +
        'body.template-product .prod_des .pad,' +
        'body.template-product .prod_des .pbu,' +
        'body.template-product .hwtusecon,' +
        'body.template-product .hwto{' +
        '--rb-variant-glow:' +
        color +
        ';--rb-feature-color:' +
        color +
        ';}';
    }
  }

  function getVariantId(form) {
    if (!form) return null;
    var select = form.querySelector('select[name="id"]');
    if (select && select.value) return String(select.value);
    var input = form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    var checked = form.querySelector('[name="id"]:checked');
    return checked ? String(checked.value) : null;
  }

  function getSelectedFormula(root, formulaOptionIndex) {
    if (formulaOptionIndex === null || formulaOptionIndex === undefined) return null;
    var option = root.querySelector(
      '[data-swatch-option][data-id="' + formulaOptionIndex + '"]'
    );
    if (!option) return null;
    var selected = option.querySelector('[data-swatch-item].is--selected');
    if (selected && selected.getAttribute('data-value')) {
      return selected.getAttribute('data-value');
    }
    var current = option.querySelector('[data-current-value]');
    return current ? current.textContent.trim() : null;
  }

  function resolveColor(data, form, root) {
    var byId = (data && data.byId) || data || {};
    var byFormula = (data && data.byFormula) || {};
    var formulaIndex = data && data.formulaOptionIndex;

    var formula = getSelectedFormula(root, formulaIndex);
    if (formula && byFormula[formula]) {
      return byFormula[formula];
    }

    var id = getVariantId(form);
    if (id && byId[id]) return byId[id];

    return root.style.getPropertyValue('--rb-variant-glow') || '#246844';
  }

  function initGlow(root, opts) {
    opts = opts || {};
    if (!root) return;
    if (root.dataset.rbGlowReady === 'true' && !opts.force) return;
    root.dataset.rbGlowReady = 'true';

    var jsonEl = root.querySelector('[data-rb-variant-glow-json]');
    var data = {};
    if (jsonEl) {
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (err) {
        data = {};
      }
    }

    if (!data.byId && !data.byFormula) {
      data = { byId: data, byFormula: {}, formulaOptionIndex: null };
    }

    var form =
      root.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    var lastColor = '';

    function sync() {
      var hex = resolveColor(data, form, root);
      var normalized = normalizeHex(hex) || '#246844';
      if (normalized === lastColor) return;
      lastColor = normalized;
      applyGlow(root, normalized);
    }

    applyGlow(root, resolveColor(data, form, root));
    lastColor = normalizeHex(resolveColor(data, form, root)) || '#246844';
    glowSyncByRoot.set(root, sync);
    sync();

    if (form) {
      form.addEventListener(
        'change',
        function (event) {
          var t = event.target;
          if (!t || !t.name) return;
          if (t.name === 'id' || t.name.indexOf('option') === 0) sync();
        },
        true
      );
    }

    // Paint on pointerdown so color updates before the click finishes / theme JS runs.
    root.addEventListener(
      'pointerdown',
      function (event) {
        var swatch = event.target.closest('[data-swatch-item]');
        if (!swatch || !root.contains(swatch)) return;

        var option = swatch.closest('[data-swatch-option]');
        var optionId = option ? option.getAttribute('data-id') : null;
        if (
          optionId !== null &&
          String(optionId) === String(data.formulaOptionIndex)
        ) {
          var formulaValue = swatch.getAttribute('data-value');
          if (formulaValue && data.byFormula && data.byFormula[formulaValue]) {
            lastColor = '';
            applyGlow(root, data.byFormula[formulaValue]);
            lastColor = normalizeHex(data.byFormula[formulaValue]) || lastColor;
          }
        }
      },
      true
    );

    root.addEventListener(
      'click',
      function (event) {
        var swatch = event.target.closest('[data-swatch-item]');
        if (!swatch || !root.contains(swatch)) return;

        var option = swatch.closest('[data-swatch-option]');
        var optionId = option ? option.getAttribute('data-id') : null;
        if (
          optionId !== null &&
          String(optionId) === String(data.formulaOptionIndex)
        ) {
          var formulaValue = swatch.getAttribute('data-value');
          if (formulaValue && data.byFormula && data.byFormula[formulaValue]) {
            lastColor = '';
            applyGlow(root, data.byFormula[formulaValue]);
            lastColor = normalizeHex(data.byFormula[formulaValue]) || lastColor;
          }
        }

        window.requestAnimationFrame(sync);
        setTimeout(sync, 0);
        setTimeout(sync, 50);
      },
      true
    );

    var watchTargets = [];
    if (data.formulaOptionIndex !== null && data.formulaOptionIndex !== undefined) {
      var formulaOption = root.querySelector(
        '[data-swatch-option][data-id="' + data.formulaOptionIndex + '"]'
      );
      if (formulaOption) watchTargets.push(formulaOption);
    }
    if (form) {
      var idField = form.querySelector('select[name="id"], input[name="id"]');
      if (idField) watchTargets.push(idField);
    }

    if (watchTargets.length && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        sync();
      });
      watchTargets.forEach(function (el) {
        observer.observe(el, {
          attributes: true,
          childList: true,
          subtree: true,
          characterData: true,
        });
      });
    }

    // Feature cards / howto may render after this script — re-paint when they appear.
    if (window.MutationObserver && document.body) {
      var lateObserver = new MutationObserver(function () {
        sync();
      });
      lateObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        lateObserver.disconnect();
      }, 4000);
    }
  }

  function bindGlobalGlow() {
    if (globalGlowBound || !window.jQuery) return;
    globalGlowBound = true;
    window.jQuery(document)
      .off('change.rbGlow')
      .on('change.rbGlow', 'select[name="id"], input[name="id"]', function () {
        document.querySelectorAll('[data-rb-variant-glow]').forEach(function (root) {
          var sync = glowSyncByRoot.get(root);
          if (sync) sync();
        });
      });
  }

  function bootScope(scope) {
    if (!isProductPage()) return;
    var scopeEl = scope && scope.querySelectorAll ? scope : document;
    scopeEl.querySelectorAll('[data-rb-variant-glow]').forEach(function (root) {
      initGlow(root, { force: true });
    });
  }

  function bootAll() {
    bindGlobalGlow();
    bootScope(document);
  }

  function peekGlowFromMarkup(scope) {
    if (!scope || !scope.querySelector) return;
    var glowRoot = scope.querySelector('[data-rb-variant-glow]');
    if (!glowRoot) return;
    var inline = glowRoot.style.getPropertyValue('--rb-variant-glow');
    if (inline && inline.trim()) {
      applyGlow(glowRoot, inline.trim());
    }
  }

  window.rbInitVariantGlow = bootScope;
  window.rbApplyVariantGlow = applyGlow;
  window.rbPeekVariantGlow = peekGlowFromMarkup;

  // Run as soon as this script parses (placed right after glow root + JSON).
  bindGlobalGlow();
  if (document.body) {
    bootAll();
  }
  onReady(bootAll);
})();
